import React from 'react';
import { Grid, Segment } from 'semantic-ui-react';
import AttachmentView from '../../../common/AttachmentView';
import ApiService from '../../../../service/apiService';
import logUtils from '../../../../HelperMethods/LogUtils';
import { TaskFormField } from './lib/constants';
import { getFileName } from '../../../../HelperMethods/UtilityFunctions';

export default function TaskAttachmentSegment({ taskType, attachmentSchema, formik, task, location }) {
  const [tTAttachments, setTTAttachments] = React.useState([]);
  React.useEffect(() => {
    async function fetchAttachments() {
      setTTAttachments([]);
      if (taskType?.originalobject?.attachmentIds?.length > 0) {
        try {
          const attachments = await ApiService.getEntitiesByIds(taskType.originalobject.attachmentIds, 'attachment');
          setTTAttachments(attachments.filter((a) => !a.isDeleted));
        } catch (e) {
          logUtils.logError(e, 'Attachment Loading Failed');
        }
      }
    }
    fetchAttachments();
  }, [taskType]);
  if (!tTAttachments?.length && !attachmentSchema && !location?.attachments?.length) return null;
  return (
    <Segment style={{ border: '1px solid #e5e5e5', marginTop: '50px' }}>
      {tTAttachments?.length > 0 && (
        <Grid style={{ paddingBottom: attachmentSchema ? '30px' : '0px' }}>
          <Grid.Row className="form-group-header">Task Type Attachments</Grid.Row>
          <Grid.Row style={{ marginLeft: '5px' }}>
            <Grid.Column width={16}>
              <Grid style={{ marginTop: '0px', marginBottom: '0px', paddingLeft: '10px' }}>
                <Grid.Row>
                  {tTAttachments.map((attachment) => (
                    <AttachmentView key={attachment.id} attachment={attachment} name={attachment.name} isDownloadable />
                  ))}
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )}
      {attachmentSchema && <TaskFormField formik={formik} attributeObj={attachmentSchema} task={task} />}
      {location?.attachments?.length > 0 && (
        <Grid style={{ paddingBottom: attachmentSchema ? '30px' : '0px' }}>
          <Grid.Row className="form-group-header">Location Attachments</Grid.Row>
          <Grid.Row style={{ marginLeft: '5px' }}>
            <Grid.Column width={16}>
              <Grid style={{ marginTop: '0px', marginBottom: '0px', paddingLeft: '10px' }}>
                <Grid.Row>
                  {location.attachments
                    .filter((attachment) => attachment.key)
                    .map((attachment, index) => (
                      <AttachmentView
                        key={index}
                        attachment={attachment}
                        name={attachment.name || attachment.fileName || getFileName(attachment.key)}
                        isDownloadable
                      />
                    ))}
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )}
    </Segment>
  );
}
